export const availableDeviceModels = {
  circuits: {
    NVent910: 'NVent 910',
    NVent920: 'Nvent 920',
    NVentNGC20: 'NVent NGC20',
    NVentNGC30: 'NVent NGC30',
    NVentNGC40: 'NVent NGC40',
    NVentNGC40HTC3: 'NVent NGC40 HTC3',
    NVentCM2000P: 'NVent AC2000+',
    ThermonTCM2: 'Thermon TCM2',
    ThermonTCM18: 'Thermon TCM18',
    ThermonTC101: 'Thermon TC101',
    ThermonTC201: 'Thermon TC201',
    ThermonTC202: 'Thermon TC202',
    ThermonTC1818: 'Thermon TC1818',
    ThermonGenesis: 'Thermon Genesis',
    MasterTraceMS: 'MasterTrace MS',
    SmartTraceMP: 'SmartTrace Monitored Panel',
    ChromaloxITLSC1D2EXT: 'Chromalox ITLSC1D2',
    Elexant4020i: 'Elexant 4020i',
    Elexant4010i: 'Elexant 4010i',
    Elexant5010i: 'Elexant 5010i',
    Raychem7300i: 'Raychem 7300i',
    RaptorPLC: 'Raptor PLC',
  },
  controllers: {
    NVentNGC20Controller: 'NVent NGC20 Controller',
    NVentNGC30Controller: 'NVent NGC30 Controller',
    NVentNGC40Controller: 'NVent NGC40 Controller',
    NVentCM2000PController: 'NVent AC2000+ Controller',
    ThermonTCM2Controller: 'Thermon TCM2 Controller',
    ThermonTCM18Controller: 'Thermon TCM18 Controller',
    ThermonTC101Controller: 'Thermon TC101 Controller',
    ThermonTC201Controller: 'Thermon TC201 Controller',
    ThermonTC202Controller: 'Thermon TC202 Controller',
    ThermonTC1818Controller: 'Thermon TC1818 Controller',
    ThermonGenesisController: 'Thermon Genesis Controller',
    MasterTraceMSController: 'MasterTrace MS Controller',
    SmartTraceMPController: 'SmartTrace Monitored Panel',
    ChromaloxITLSC1D2EXTControllerDevice: 'Chromalox ITLSC1D2 Controller',
    Elexant4020iController: 'Elexant 4020i Controller',
    Elexant4010iController: 'Elexant 4010i Controller',
  }
} as const;

// Type helpers
export type CircuitModel = keyof typeof availableDeviceModels.circuits;
export type ControllerModel = keyof typeof availableDeviceModels.controllers;
export type DeviceModel = CircuitModel | ControllerModel;
